import { useRef } from "react";
import { DictionaryMeaning } from "services/dictionary";
import Action from "components/formElements/Action/Action";
import audioImg from "../images/audio.svg";
import noAudioImg from "./images/noAudio.svg";
import "./DictionaryItem.css";

type DictionaryItemProps = {
  pos: string;
  items: DictionaryMeaning[];
};

export default function DictionaryItem({ pos, items }: DictionaryItemProps) {
  return (
    <div className="dictionary-item">
      <div className="dictionary-item-header">
        <span>{pos}</span>
      </div>
      {items.map((item, index) => (
        <DefinitionItem key={index} item={item} />
      ))}
      <div className="separator"></div>
    </div>
  );
}

function DefinitionItem({ item }: { item: DictionaryMeaning }) {
  return (
    <div className="definition-item">
      <div>
        <PronunciationAudio pronunciation={item.pronunciation.audio} />
        {item.pronunciation.phonetic && (
          <div className="transcription">
            <span>{`/${item.pronunciation.phonetic}/`}</span>
          </div>
        )}
        <span className="definition">{item.definition}</span>
        {/* For now, we don't show a term's domain. */}
      </div>
      <div className="examples-list">
        {item.examples.map((example, index) => (
          <div className="example" key={index}>
            {example}
          </div>
        ))}
      </div>
    </div>
  );
}

function PronunciationAudio({ pronunciation }: { pronunciation: string | null }) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const onAudioPlay = () => {
    audioRef.current?.play();
  };

  if (!pronunciation) {
    return (
      <div className="pronunciation">
        <img src={noAudioImg} alt="no audio available" />
      </div>
    );
  }

  return (
    <div className="pronunciation">
      <span>
        <Action className="audio-btn" onClick={onAudioPlay}>
          <img src={audioImg} alt="audio" />
        </Action>
        {/* key + direct src: mutating a <source> child never reloads an existing media element */}
        <audio
          key={pronunciation}
          src={pronunciation}
          controlsList="nodownload"
          ref={audioRef}
        />
      </span>
    </div>
  );
}
